/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-irregular-whitespace */
import React, { FC } from 'react';
import Page from 'src/shared-components/Page/Page';
import Constraints from 'src/shared-components/Constraints/Constraints';
import { FormattedMessage, defineMessages } from 'react-intl';
import { BreadCrumbs } from 'src/shared-components/design-system/BreadCrumbs';

import { PROD_DOMAIN } from 'src/api/constants';
import {
  GetServerSideProps,
  GetServerSidePropsContext,
  GetServerSidePropsResult
} from 'next';
import { ParsedUrlQuery } from 'querystring';
import Head from 'next/head';
import { robotsTagContent } from 'src/utils/seo';
import { fetchCache } from 'src/api/caching/cacheUtils';
import { triggerCustomStatusCodeRedirect } from 'src/ssr/errorStatusCodeRedirect';
import {
  GeneralServerProps,
  generalSSRProps,
  getCacheConfig,
  isQueryParamsValid,
  setSSRCacheControl
} from '../ssr/generalSsrUtil';
import { Category } from '../api/types';

interface Props extends GeneralServerProps {
  categoriesList: Category[];
}
const trns = defineMessages({
  homeBreadCrumb: {
    id: '/YV5ee',
    defaultMessage: 'Головна'
  },
  privacyPolicyBreadCrumb: {
    id: 'u/s7LA',
    defaultMessage: 'Правила та умови'
  }
});

const headingStyle = 'text-astronautBlue fs-header5-bold py-8';
const subHeadingStyle = 'text-astronautBlue fs-header5-bold py-8';
const regularParagraphStyle = 'font-light text-gray300 py-2';

const PrivacyPolicyPage: FC<Props> = () => {
  return (
    <>
      <Head>
        <meta name="robots" content={robotsTagContent} key="robots" />
      </Head>
      <Page>
        <BreadCrumbs
          items={[
            {
              id: 'home',
              title: <FormattedMessage {...trns.homeBreadCrumb} />,
              href: '/'
            },
            {
              id: 'privacy_policy',
              title: <FormattedMessage {...trns.privacyPolicyBreadCrumb} />,
              href: '/privacy_policy'
            }
          ]}
        />
        <Constraints className="pb-12 px-5 xl:px-0">
          <h1 className={headingStyle}>
            УГОДА ПРО КОНФІДЕНЦІЙНОСТІ ТА ЗАХИСТУ ПЕРСОНАЛЬНИХ ДАНИХ
          </h1>
          <h2 className={subHeadingStyle}>Загальні положення</h2>
          <p className={regularParagraphStyle}>
            Ця Угода розроблена ТОВАРИСТВОМ З ОБМЕЖЕНОЮ ВІДПОВІДАЛЬНІСТЮ "ЛІКИ
            24/7", код ЄДРПОУ 44519491 (надалі - ТОВ "ЛІКИ 24/7" або «Компанія»)
            відповідно до чинного законодавства України.
          </p>
          <p className={regularParagraphStyle}>
            У цій Угоді конфіденційності та захисту персональних даних (далі -
            «Угода») встановлено порядок здійснення Компанією обробки
            персональних даних, види персональних даних, які збираються, цілі
            використання таких персональних даних, взаємодія Компанії з третіми
            особами, заходи безпеки для захисту персональних даних, умови
            доступу до персональних даних, а також, контактна інформація для
            користувача щодо отримання доступу, внесення змін, блокування або
            видалення своїх персональних даних та звернення з будь-якими
            запитаннями, які можуть виникнути у користувача щодо практики
            захисту персональних даних.
          </p>
          <p className={regularParagraphStyle}>
            Ця Угода є договором приєднання відповідно до положень статті 634
            Цивільного кодексу України. Використання Користувачем Веб-сайту у
            будь-який спосіб, свідчить про приєднання Користувача до цієї Угоди
            повністю і підтверджує факт надання Згоди користувача з наведеними в
            цій Угоді умовами. Ця Угода поширюється також на відносини,
            пов'язані з правами та інтересами третіх осіб, які не є
            користувачами Сайту, але чиї права та інтереси можуть бути порушені
            в результаті дій користувачів Сайту.
          </p>
          <p className={regularParagraphStyle}>
            Якщо Ви не згодні дотримуватися цієї Угоди, будь ласка, негайно
            припиніть використання Сайту.
          </p>
          <h2 className={subHeadingStyle}>
            Збір та використання персональних даних
          </h2>
          <p className={regularParagraphStyle}>
            Володільцем та розпорядником персональних даних користувачів Сайту є
            ТОВ "ЛІКИ 24/7"юридична адреса: 02121, місто Київ, вул.Колекторна,
            будинок 3А.
          </p>
          <p className={regularParagraphStyle}>
            При використанні користувачем сервісів Сайту Компанією здійснюється
            обробка даних користувача, а саме: - даних, що надаються
            користувачем як при заповненні реєстраційних форм, так і в процесі
            користування сервісами; файли cооkie; ір-адреси; параметри і
            налаштувань інтернет-браузерів (User-agent).
          </p>
          <p className={regularParagraphStyle}>
            Компанія збирає тільки ті персональні дані (Ваше ім'я і прізвище,
            логін і пароль доступу, адреса електронної пошти, номер контактного
            телефону, адреса, місце роботи (для співробітників партнерів) будь
            які коментарі, що ви лишаєте при оформлені замовлення і т.д.), які
            свідомо і добровільно надані Вами як суб'єктом персональних даних в
            цілях використання сервісів Сайту, що відповідно до вимог
            законодавства є згодою суб'єкта персональних даних на обробку своїх
            персональних даних відповідно до сформульованої в цій Політиці мети
            їх обробки.{' '}
          </p>
          <p className={regularParagraphStyle}>
            При відвідуванні Сайту фіксуються всі входи до системи. Інші
            відомості по трафіку користувача не обробляються і не зберігаються.
          </p>
          <p className={regularParagraphStyle}>
            Звертаємо Вашу увагу: Компанія обмежується збором мінімального
            обсягу інформації, необхідного в цілях, що викладені у цій Політиці.
            У будь-якому випадку, коли запитується необов'язкова до надання
            інформація, користувача буде повідомлено в момент збору такої
            інформації.
          </p>
          <p className={regularParagraphStyle}>
            Компанія не збирає будь-яку інформацію, для обробки якої
            законодавством встановлені певні особливі вимоги, як-то інформацію
            про расове або етнічне походження, політичні, релігійні або
            світоглядні переконання, членство в політичних партіях та
            професійних спілках, засудження до кримінального покарання, а також
            даних, що стосуються здоров'я, статевого життя, біометричних або
            генетичних даних (відповідно до статті 7 Закону України «Про захист
            персональних даних»).
          </p>
          <p className={regularParagraphStyle}>
            Компанія збирає дані про статистику відвідування Сайту. Відомості
            можуть містити інформацію про з'єднання, трафік, браузер
            користувача, а також про дату, час, тривалість роботи в мережі
            Інтернет, та знаходження на Сайті.
          </p>
          <h2 className={subHeadingStyle}>
            Цілі використання персональних даних
          </h2>
          <p className={regularParagraphStyle}>
            Ваші персональні дані використовуються в цілях забезпечення надання
            Інтернет-сервісів Сайту, обміну інформацією/новинами, відносин у
            сфері реклами та комунікації, у тому числі для направлення за Вашої
            згоди персоніфікованих інформаційних повідомлень на адресу
            електронної пошти, відповідно та на виконання законів України, у
            тому числі, але не виключно: «Про захист персональних даних», «Про
            ратифікацію Конвенції про захист осіб у зв'язку з автоматизованою
            обробкою персональних даних та Додаткового протоколу до Конвенції
            про захист осіб у зв'язку з автоматизованою обробкою персональних
            даних стосовно органів нагляду та транскордонних потоків даних»,
            «Про інформацію», «Про рекламу», «Про телекомунікації», «Про захист
            інформації в інформаційно -телекомунікаційних системах», а також
            відповідно та інших актів, що регулюють діяльність Компанії та
            функціонування цього Сайту.
          </p>
          <h2 className={subHeadingStyle}>Обробка персональних даних</h2>
          <p className={regularParagraphStyle}>
            Обробка і зберігання наданих персональних даних здійснюється в
            дата-центрах, де розміщується обладнання, що забезпечує
            функціонування сервісів Сайту. Надані персональні дані обробляються
            і можуть зберігатись в Базі персональних даних чи окремій таблиці
            Бази даних Сайту.
          </p>
          <h2 className={subHeadingStyle}>
            Цілі використання персональних даних
          </h2>
          <p className={regularParagraphStyle}>
            Ваші персональні дані використовуються в цілях забезпечення надання
            Інтернет-сервісів Сайту, обміну інформацією/новинами, відносин у
            сфері реклами та комунікації, у тому числі для направлення за Вашої
            згоди персоніфікованих інформаційних повідомлень на адресу
            електронної пошти, відповідно та на виконання законів України, у
            тому числі, але не виключно: «Про захист персональних даних», «Про
            ратифікацію Конвенції про захист осіб у зв'язку з автоматизованою
            обробкою персональних даних та Додаткового протоколу до Конвенції
            про захист осіб у зв'язку з автоматизованою обробкою персональних
            даних стосовно органів нагляду та транскордонних потоків даних»,
            «Про інформацію», «Про рекламу», «Про телекомунікації», «Про захист
            інформації в інформаційно -телекомунікаційних системах», а також
            відповідно до Правил використання сайту та інших актів, що регулюють
            діяльність Компанії та функціонування цього Сайту.
          </p>
          <h2 className={subHeadingStyle}>
            Термін зберігання персональних даних
          </h2>
          <p className={regularParagraphStyle}>
            Персональні дані зберігаються на термін не більше, ніж це необхідно
            відповідно до мети їх обробки. Для видалення свого облікового запису
            Ви маєте право написати на поштову адресу Компанії: 02121, місто
            Київ, вул.Колекторна, будинок 3А.листа з проханнями видалити Ваш
            обліковий запис. В листі треба зазначити ПІБ, номер телефону,
            електрону пошту, які ви зазначали при реєстрації. Ваш обліковий
            запис буде видалено протягом двох робочих днів с моменту отримання
            Компанією такого звернення. Після того, як обліковий запис буде
            видалено на Сайті, Ваші персональні дані також автоматично
            видаляються.
          </p>
          <h2 className={subHeadingStyle}>Використання файлів cооkie</h2>
          <p className={regularParagraphStyle}>
            Cооkie - це текстовий файл або файли, що містять невеликий обсяг
            інформації, які надсилаються веб-браузеру і зберігаються на пристрої
            користувача. До таких пристроїв можна віднести комп'ютер, мобільний
            телефон або інший пристрій, за допомогою якого користувач відвідує
            Сайт. Файли cооkie можуть бути постійними і зберігатися в
            комп'ютері, поки користувач їх не видалить або тимчасовими (такі
            файли cооkie називаються сесійними), тобто зберігаються тільки до
            закриття браузера. Крім того, файли cооkie поділяються на основні
            (вони встановлюються безпосередньо відвідуваним Сайтом) і сторонні
            (встановлюються іншими веб-сайтами).
          </p>
          <p className={regularParagraphStyle}>
            При повторному відвідуванні користувачем Сайту, дані файлів cооkie
            оновлюються; у більшості випадків, веб-браузер за замовчуванням
            допускає автоматичне зберігання файлів cооkie на пристрої
            користувача;
          </p>
          <p className={regularParagraphStyle}>
            Відключення файлів cооkie може призвести до обмеження доступу до
            опублікованих матеріалів та/або неповноцінного функціонування
            сервісів Сайту.
          </p>
          <p className={regularParagraphStyle}>
            Для більш комфортного, та зручного функціонування Сайту, Компанії
            необхідно, за допомогою файлів cооkie, проаналізувати поведінку і
            інтереси користувача. Такий аналіз допоможе Компанії поліпшити
            досвід взаємодії з Сайтом, визначити найбільш зручний інтерфейс і
            навігацію Сервісу.
          </p>
          <p className={regularParagraphStyle}>
            Сайт може ділитися цією інформацією з іншими сторонами, включаючи
            медіа-клієнтів, рекламодавців, агентства і партнерів по суміжних
            бізнесах для того, щоб вони надавали якісну таргетовану рекламу.
            Cооkie -файли сторонніх сервісів і сервісів аналітики.
          </p>
          <p className={regularParagraphStyle}>
            Для оперативної доставки, більш якісного відображення і детального
            аналізу контенту на Сайті, Компанія користується послугами, які є
            власністю інших сторонніх компаній, таких як Facebook, Twitter,
            Instagram та інші.
          </p>
          <p className={regularParagraphStyle}>
            Наведені як приклад компанії можуть використовувати файли cооkie на
            пристрої користувача, під час роботи на Сайті.
          </p>
          <p className={regularParagraphStyle}>
            Сайт не може вплинути на роботу файлів cооkie, які використовуються
            цими сервісами. Всі необхідні відомості про їх використання можна
            дізнатися, відвідавши відповідний ресурс.
          </p>
          <p className={regularParagraphStyle}>
            Умови використання{' '}
            <a
              className="text-astronautBlue "
              href="https://marketingplatform.google.com/about/analytics/terms/ru/"
            >
              Google Analytics
            </a>{' '}
          </p>
          <p className={regularParagraphStyle}>Управління файлами cookie:</p>
          <p className={regularParagraphStyle}>
            Основні веб-браузери (перераховані нижче) налаштовані на
            автоматичний прийом файлів cооkie. Для того щоб їх відключити
            скористайтеся функцією довідки в своєму браузері.
          </p>
          <p className={regularParagraphStyle}>
            Довідку можна викликати через меню або за допомогою кнопки F1.
          </p>
          <p className={regularParagraphStyle}> Microsoft Edge</p>
          <p className={regularParagraphStyle}> Mozilla Firefox</p>
          <p className={regularParagraphStyle}> Google Chrome</p>
          <p className={regularParagraphStyle}> Opera</p>
          <p className={regularParagraphStyle}>
            Якщо користувач не включає використання файлів cооkie або навмисно
            видаляє всі файли cооkie зі свого веб-браузера, то при подальшому
            відвідуванні Сайту, користувачеві буде повторно пропонуватися
            включення і використання файлів cооkie.
          </p>
          <p className={regularParagraphStyle}>
            Інформація про користувачів отримана за допомогою файлів cооkie не
            продається і не поширюється у відкритому доступі, а також є
            власністю компанії, якій належить ресурс.
          </p>
          <h2 className={subHeadingStyle}>
            Взаємодія Сайту з іншими ресурсами
          </h2>
          <p className={regularParagraphStyle}>
            При використанні користувачем сервісів, на сторінках Сайту можуть
            бути присутніми коди інших інтернет ресурсів і третіх осіб, в
            результаті чого такі інтернет ресурси і треті особи отримують Ваші
            дані. Отже, ці інтернет-ресурси можуть отримувати і обробляти
            інформацію, про те, що Ви відвідали ці сторінки, а також іншу
            інформацію, яку передає браузер користувача. Такими
            інтернет-ресурсами можуть бути: системи банеропоказів (наприклад,
            DoubleClick for Publishers, Admixer, AdRiver та ін.); соціальні
            плагіни мереж (наприклад, Facebook) та ін.
          </p>
          <p className={regularParagraphStyle}>
            Використання зазначених сервісів Компанії може бути необхідно для
            оперативного аналізу відвідувань Сайту, внутрішньої і зовнішньої
            оцінки відвідуваності Сайту, глибини переглядів, активності
            користувачів. Дані, отримані від зазначених сервісів Компанія не
            зберігає і не обробляє.
          </p>
          <p className={regularParagraphStyle}>
            Відповідно, якщо користувач в силу будь-яких причин не бажає, щоб
            зазначені сервіси отримували доступ до його персональних даних,
            користувач може за власним бажанням вийти зі свого аккаунта чи
            профіля, очистити файли cооkie (через свій браузер).
          </p>
          <h2 className={subHeadingStyle}>
            Взаємодія Компанії з третіми особами стосовно персональних даних
          </h2>
          <p className={regularParagraphStyle}>
            Компанія може передавати персональні дані користувачів третім
            особам. Зокрема, торговельним мережам та аптекам, в яких користувач
            робить замовлення за допомогою Сайту, з метою налагодження
            зворотнього зв'язку між аптекою і користувачем. Також, у випадках,
            коли така передача є вимогою законодавства, на прохання суб'єкта
            персональних даних або в інших випадках, викладених в цій Політиці.
            Компанія розуміє, що особиста інформація є цінністю і невід'ємним
            змістом, в тому числі, особистих немайнових прав будь-якої фізичної
            особи, тому вживає всіх можливих заходів для захисту особистої
            інформації користувачів, добровільно і усвідомлено переданої
            останніми Компанії.
          </p>
          <p className={regularParagraphStyle}>
            На Сайті можуть бути посилання на інші веб-сайти (виключно в
            інформаційних цілях). При переході по посиланню на інші веб-сайти
            дія цієї Угоди на такі сайти поширюватися не буде. У зв'язку з чим,
            Компанія рекомендує переглядати політику в сфері конфіденційності і
            персональних даних кожного веб-сайту перед тим, як передавати
            будь-які персональні дані, за якими Вас можуть ідентифікувати.
          </p>
          <h2 className={subHeadingStyle}>Безпека неповнолітніх</h2>
          <p className={regularParagraphStyle}>
            Сайт не призначений для неповнолітніх користувачів, в зв'язку з чим
            Компанія звертається до батьків із закликом пояснити своїм дітям
            правила безпеки в мережі Інтернет, про конкретну мету і потребу у
            використанні тих чи інших сервісів Сайту.
          </p>
          <h2 className={subHeadingStyle}>
            Конфіденційність активності суб'єкта персональних даних на Сайті
          </h2>
          <p className={regularParagraphStyle}>
            Відомості про активність (трафік) на Сайті користувачів, які
            проходять через мережу, або електронну пошту користувача захищені
            відповідно до законодавства. Компанія жодним чином або способом не
            порушує таємницю «активності» користувача при використанні останнім
            сервісів Сайту.
          </p>
          <h2 className={subHeadingStyle}>Захист персональних даних</h2>
          <p className={regularParagraphStyle}>
            Компанія використовує загальноприйняті стандарти технологічного та
            операційного захисту інформації та персональних даних від втрати,
            неправильного використання, зміни або знищення. Однак, не дивлячись
            на всі зусилля, Компанія не може гарантувати абсолютну захищеність
            від будь-яких загроз, що виникають поза межами регулювання Компанії.
          </p>
          <p className={regularParagraphStyle}>
            Компанія надає доступ до інформації і персональних даних тільки
            своїм уповноваженим працівникам, а також правоохоронним, судовим
            органам, у передбачених чинним законодавством випадках. Поширення
            персональних даних без згоди суб'єкта персональних даних або
            уповноваженої ним особи дозволяється у випадках, визначених законом,
            і лише (якщо це необхідно) в інтересах національної безпеки,
            економічного добробуту та прав людини.
          </p>
          <h2 className={subHeadingStyle}>Права суб'єкта персональних даних</h2>
          <p className={regularParagraphStyle}>
            Компанія доводить до Вашого відома про Ваші права, як суб'єкта
            персональних даних, які врегульовані Законом України «Про захист
            персональних даних», а саме:
          </p>
          <p className={regularParagraphStyle}>
            знати про джерела збирання, місцезнаходження своїх персональних
            даних, мету їх обробки, місцезнаходження або місце проживання
            (перебування) володільця чи розпорядника персональних даних або дати
            відповідне доручення щодо отримання цієї інформації уповноваженим
            ним особам, крім випадків, встановлених законом;
          </p>
          <p className={regularParagraphStyle}>
            отримувати інформацію про умови надання доступу до персональних
            даних, зокрема інформацію про третіх осіб, яким передаються його
            персональні дані;
          </p>
          <p className={regularParagraphStyle}>
            на доступ до своїх персональних даних;
          </p>
          <p className={regularParagraphStyle}>
            отримувати не пізніш як за тридцять календарних днів з дня
            надходження запиту, крім випадків, передбачених законом, відповідь
            про те, чи обробляються його персональні дані, а також отримувати
            зміст таких персональних даних;
          </p>
          <p className={regularParagraphStyle}>
            пред'являти вмотивовану вимогу володільцю персональних даних із
            запереченням проти обробки своїх персональних даних;
          </p>
          <p className={regularParagraphStyle}>
            пред'являти вмотивовану вимогу щодо зміни або знищення своїх
            персональних даних будь-яким володільцем та розпорядником
            персональних даних, якщо ці дані обробляються незаконно чи є
            недостовірними;
          </p>
          <p className={regularParagraphStyle}>
            на захист своїх персональних даних від незаконної обробки та
            випадкової втрати, знищення, пошкодження у зв'язку з умисним
            приховуванням, ненаданням чи несвоєчасним їх наданням, а також на
            захист від надання відомостей, що є недостовірними чи ганьблять
            честь, гідність та ділову репутацію фізичної особи;
          </p>
          <p className={regularParagraphStyle}>
            звертатися із скаргами на обробку своїх персональних даних до
            Уповноваженого Верховної Ради України з прав людини або до суду;
          </p>
          <p className={regularParagraphStyle}>
            застосовувати засоби правового захисту в разі порушення
            законодавства про захист персональних даних;
          </p>
          <p className={regularParagraphStyle}>
            вносити застереження стосовно обмеження права на обробку своїх
            персональних даних під час надання згоди;
          </p>
          <p className={regularParagraphStyle}>
            відкликати згоду на обробку персональних даних;
          </p>
          <p className={regularParagraphStyle}>
            знати механізм автоматичної обробки персональних даних;
          </p>
          <p className={regularParagraphStyle}>
            на захист від автоматизованого рішення, яке має для нього правові
            наслідки.
          </p>
          <p className={regularParagraphStyle}>
            Для оновлення, отримання доступу, внесення змін, блокування або
            видалення своїх персональних даних, відкликання згоди на обробку
            персональних даних, яка була Вами надана Компанії відповідно до цієї
            Угоди, або в разі наявності будь-яких зауважень, побажань або
            претензій щодо Ваших персональних даних, які обробляються Компанією,
            будь-ласка, звертайтеся до Компанії на адресу: 02121, місто Київ,
            вул.Колекторна, будинок 3А.
          </p>
          <h2 className={subHeadingStyle}>
            Умови доступу до персональних даних
          </h2>
          <p className={regularParagraphStyle}>
            Порядок доступу до персональних даних третіх осіб визначається
            умовами згоди користувача, наданої володільцю персональних даних на
            обробку цих даних, або відповідно до вимог закону.
          </p>
          <p className={regularParagraphStyle}>
            Користувач має право на одержання будь-яких відомостей про себе у
            будь-якого суб'єкта відносин, пов'язаних з персональними даними, за
            умови зазначення прізвища, ім'я та по батькові, місця проживання
            (місця перебування) і реквізитів документа, що посвідчує фізичну
            особу, яка подає запит, крім випадків, установлених законом.
          </p>
          <p className={regularParagraphStyle}>
            Доступ користувача до даних про себе здійснюється безоплатно.
          </p>
          <h2 className={subHeadingStyle}>Зміна Угоди </h2>
          <p className={regularParagraphStyle}>
            До цієї Угоди періодично та без попереднього повідомлення
            користувача про таке можуть вноситись зміни та доповнення, у тому
            числі, при зміні вимог чинного законодавства України.
          </p>
          <p className={regularParagraphStyle}>
            У випадку внесення істотних змін до цієї Угоди Компанією буде
            розміщено повідомлення на Сайті та зазначено термін набрання цими
            змінами чинності. Якщо протягом зазначеного терміну Ви не
            відмовитеся від їх прийняття в письмовій формі, це означатиме, що Ви
            погоджуєтеся з відповідними змінами Угоди.
          </p>
          <p className={regularParagraphStyle}>
            Просимо час від часу переглядати Угоду для того, щоб бути в курсі
            будь-яких змін або доповнень.
          </p>
          <h2 className={subHeadingStyle}>Відповідальність за самолікування</h2>
          <p className={regularParagraphStyle}>
            <a className="text-astronautBlue " href={PROD_DOMAIN}>
              Сайт
            </a>{' '}
            не є медичною установою. Сайт надає посередницькі послуги між
            аптеками і покупцем щодо інформації про наявність лікарських
            засобів, виробів медичного призначення, або інших товарів (надалі
            разом як – «товар»), дозволеними до реалізації в аптечних установах,
            з можливістю їх безкоштовного бронювання. Тому даний сайт не несе
            відповідальність у випадках самолікування покупцями після придбання
            зазначеного товару за допомогою сайту
          </p>
          <h2 className={subHeadingStyle}>
            Щодо гарантії якості медичних препаратів, лікарських засобів,
            виробів медичного призначення.
          </h2>
          <p className={regularParagraphStyle}>
            Сайт не є медичною установою. Сайт надає посередницькі послуги між
            аптеками і покупцем щодо інформації про наявність лікарських
            засобів, виробів медичного призначення, або інших товарів (надалі
            разом як – «товар»), дозволеними до реалізації в аптечних установах,
            з можливістю їх безкоштовного бронювання. Тому сайт не несе
            відповідальність за гарантію якості товару.
          </p>
        </Constraints>
      </Page>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext<ParsedUrlQuery>
) => {
  setSSRCacheControl(context);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return fetchCache<GetServerSidePropsResult<{ [key: string]: any }>>(
    getCacheConfig(context),
    async () => {
      const generalProps = await generalSSRProps(context);
      if (!isQueryParamsValid(context.query)) {
        // Redirect to 410 because the URL contains invalid query params
        return triggerCustomStatusCodeRedirect(context.res, 410);
      }

      return {
        props: {
          ...generalProps
        }
      };
    }
  );
};

export default PrivacyPolicyPage;
